// client/src/hooks/useSocketEvent.ts
import { useEffect, useRef } from "react";
import { getSocket } from "../helpers/socket";

/**
 * Subscribe to one socket event for the lifetime of the component. The
 * handler ref is refreshed on every render so callers can pass inline
 * closures without re-subscribing.
 */
export function useSocketEvent<T>(
  event: string,
  handler: (payload: T) => void,
): void {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    const socket = getSocket();
    if (!socket) return;
    const listener = (payload: T) => handlerRef.current(payload);
    socket.on(event, listener);
    return () => {
      socket.off(event, listener);
    };
  }, [event]);
}
